/**
 * Asynchronously loads the component for NotFoundPage
 */

import { lazyLoad } from 'utils/loadable';

export const SettingBuyingPage = lazyLoad(
  () => import('./index'),
  module => module.SettingBuyingPage
);
